<template>
    <div>
        <h1>本日精選管理</h1>
        <full-calendar
          ref="calendar"
          :events="fcEvents"
          locale="en"
          @dayClick="list_page"
          @changeMonth="changeMonth"
        >
        </full-calendar>
        <LoadingBlock
          :active="loading">
        </LoadingBlock>
    </div>
</template>

<script>
import axios from 'axios'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import fullCalendar from 'vue-fullcalendar'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'

export default {
  mixins: [breadcrumbMixin],
  components: {
    fullCalendar,
    LoadingBlock,
  },
  created: async function () {
    this.permission_check({
      resource_info: { name: this.page_name.PAGE_RECOMMENDED_ARTICLE_MANAGEMENT },
      access: { name: this.permission.VIEW },
      reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
    })

    console.log('RecommendedArticleManagementPage: created func')

    await this.get_calendar_data()
  },
  data() {
    return {
      loading: false,
      fcEvents: [],
      route_root: 'front-stage-management/recommended-article-management',
      resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/recommended-article',
    }
  },
  mounted() {
    let events_day = document.getElementsByClassName("events-day")
    console.log("events_day: ", events_day)
    var mouseOver = function() {
      this.addClass('today')
      // let dayCell = this.querySelector('.day-cell')
      // dayCell.setAttribute("style", "background-color: #fcf8e3;")
      // var attribute = this.getAttribute("data-myattribute");
      // alert('dd');
    };
    var mouseOut = function() {
      this.classList.remove('today')
      // let dayCell = this.querySelector('.day-cell')
      // this.setAttribute("style", "background-color: #ffffff;")
      // var attribute = this.getAttribute("data-myattribute");
      // alert('dd');
    };
  },
  methods: {
    list_page(day, jsEvent) {
      let formatted_date = day.getFullYear() + "-" + ("0" + (day.getMonth() + 1)).slice(-2) + "-" + ("0" + day.getDate()).slice(-2)
      console.log("list_page (date): ", formatted_date)
      this.backstage_router_push({ path: `/${this.route_root}/list/${formatted_date}` })
    },
    changeMonth(start, end, current) {
      let today = new Date();
      let nowYear = today.getFullYear()
      console.log("nowYear: ", nowYear)
      let changedYear = parseInt(current.slice(0, 4), 10)
      console.log("changedYear: ", changedYear)
      let nowMonth = today.getMonth() + 1
      console.log("nowMonth: ", nowMonth)
      let changedMonth = parseInt(current.slice(5, 7), 10)
      console.log("changedMonth: ", changedMonth)
      let next_month = document.getElementsByClassName("next-month")[0]
      console.log("next_month: ", next_month)
      if(next_month===undefined || next_month===null) {
        return 
      }
      if(nowYear > changedYear) {
        next_month.setAttribute("style", "pointer-events: auto;")
      }else if(nowYear == changedYear) {
        if(changedMonth - nowMonth >= 1) {
          next_month.setAttribute("style", "pointer-events: none;")
        }else {
          next_month.setAttribute("style", "pointer-events: auto;")
        }
      }else {
        next_month.setAttribute("style", "pointer-events: none;")
      }
    },
    async get_calendar_data() {
      let self = this

      this.loading = true
  
      await axios.post(this.resource_api+'/calendar-list')
        .then((response) => {
          console.log('reponse: ', response.data.payload)
          if(response.data.success) {
            response.data.payload['search_result'].forEach( item => {
              this.fcEvents.push({
                title: item['title'],
                start: item['selected_date']['date'],
                cssClass : 'family'
              })
            })
            // this.$refs.calendar.$emit('refetch-events')
            // this.preloaded_data_update_flag += 1
          }else {
            this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', response.data.message)
          }
        })
        .catch(err => {
            console.log(err)
            this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', this.ERROR.MSG.general_err_msg)
        })


        this.loading = false
    }
  }
};

</script>

<style>
</style>
